import "./App.css";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Accounts from "./Pages/Account";
import Home from "./Pages/Home";
import Logins from "./Pages/Login";
import Stores from "./Pages/Store";
import Spinner from "./components/Spinner/spinner";
import PaystackIntegration from "./components/PaystackIntegration";
import { Fragment, useContext } from "react";
import { CartContext } from "./CartContext";
import Trouser from "./components/Store/Trousers";
import StoreDetails from "./components/Store/StoreDetails";
import Contact from "./components/Account/contact/contact";

import { useEffect, useState } from "react";
import Carts from "./Pages/Cart";
import HeaderCartButton from "./components/Header&Footer/HeaderCartButton";
import ResetPassword from "./Pages/ResetPassword";
import Shirts from "./components/Store/Shirts";
import Gowns from "./components/Store/PartyGowns";
import CropTop from "./components/Store/Croptop";
import SuccessPage from "./components/success/SuccessPage";
import Shoes from "./components/Store/shoes";
import Profiles from "./Pages/Profile";
import UserProfile from "./components/Account/profile/UserProfile";
import Faq from "./components/Account/FAQ/FAQ";
import Wallet from "./components/Account/wallet/Wallet";
import Address from "./components/Account/profile/Address";

function App() {
  const context = useContext(CartContext);
  const [cart, setCart] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [showCart, setShowCart] = useState(false);
  const [formData, setFormData] = useState();
  const login = useContext(CartContext);
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [id, setId] = useState();

  const isLogged = context.isLoggedIn;

  const fetchData = async () => {
    setIsLoading(true);
    const response = await fetch(
      "https://dc-lux-default-rtdb.firebaseio.com/cart.json"
    );
    const data = await response.json();

    const loadedCart = [];

    for (const key in data) {
      loadedCart.push({
        id: key,
        name: data[key].name,
        price: data[key].price,
        image: data[key.image],
      });
    }

    setCart(loadedCart);
    setIsLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const showCartHandler = () => {
    setShowCart(true);
  };

  const hideCartHandler = () => {
    setShowCart(false);
  };

  function loginHandler(email, password) {
    fetch(
      "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyCilTl0dDYnSgzy29JLmkLF857SH-WWEx0",
      {
        method: "POST",
        body: JSON.stringify({
          email: email,
          password: password,
          returnSecureToken: true,
        }),
        headers: {
          "content-type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log(response);
        if (response.ok) {
          setIsLoading(false);
          return response.json();
        } else {
          setIsLoading(false);
          return response.json().then((data) => {
            throw new Error(data.error.errors[0].message);
          });
        }
      })
      .then((data) => {
        setId(login.localID(data.localId));
        login.login(data.idToken);
        navigate("/");
      })
      .catch((err) => {
        setError(err.message);
      });
  }
  localStorage.setItem("id", id);
  return (
    <Fragment>
      {isLoading && <Spinner />}
      {showCart && (
        <Carts
          id={id}
          loading={isLoading}
          isLoading={setIsLoading}
          showCart={showCartHandler}
          hideCart={hideCartHandler}
        />
      )}
      {isLogged && <HeaderCartButton showCart={showCartHandler} />}
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route
          path="/home"
          index
          element={
            <Home
              formData={formData}
              setFormData={setFormData}
              isLoading={setIsLoading}
            />
          }
        />
        {!isLogged && (
          <Route
            path="/register"
            element={<Accounts loading={isLoading} isLoading={setIsLoading} />}
          />
        )}
        {!isLogged && (
          <Route
            path="/login"
            element={
              <Logins
                error={error}
                onLogin={loginHandler}
                loading={isLoading}
                isLoading={setIsLoading}
              />
            }
          />
        )}
        {isLogged && <Route path="/user" element={<Profiles />} />}
        <Route path="/store" element={<Stores />} />
        {isLogged && <Route path="/trouser" element={<Trouser />} />}
        {isLogged && <Route path="/shirts" element={<Shirts />} />}
        {isLogged && <Route path="/gown" element={<Gowns />} />}
        {isLogged && <Route path="/croptop" element={<CropTop />} />}
        {isLogged && <Route path="/shoes" element={<Shoes />} />}
        {isLogged && (
          <Route path="/store/:storeId" element={<StoreDetails />} />
        )}
        <Route path="/profile/address" element={<Address id={id} />} />
        {isLogged && <Route path="/profile/wallet" element={<Wallet />} />}
        {isLogged && <Route path="/profile/faq" element={<Faq />} />}
        {isLogged && <Route path="/profile/contact" element={<Contact />} />}
        {isLogged && <Route path="/profile/*" element={<UserProfile />} />}
        {isLogged && (
          <Route path="/payment" element={<PaystackIntegration />} />
        )}
        {isLogged && <Route path="/success" element={<SuccessPage />} />}
        <Route
          path="/reset"
          element={
            <ResetPassword loading={isLoading} isLoading={setIsLoading} />
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Fragment>
  );
}

export default App;
